import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";
import useUser from "../auth/useUser";
import WorkspaceAPI from "../../api/WorkspaceAPI";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { handleWorkspacesUpdate } from "../../../utils/WorkspaceUtils";

const empty: any[] = [];

const useWorkspaces = () => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const tenantID = useAtomValue(tenantIDAtom);
  const { user } = useUser();

  const workspaces = useQuery({
    queryKey: ["workspaces", tenantID],
    queryFn: () =>
      WorkspaceAPI.getAllWorkspaces().then((data) => {
        const workspaces = data?.data?.data?.workspaces ?? [];

        const result = handleWorkspacesUpdate(workspaces, user);

        return result;
      }),
    enabled: queriesEnabled && !!user && !!tenantID,
    staleTime: Infinity,
  });

  return {
    defaultWorkspace: workspaces.data?.defaultWorkspace,
    workspaces: workspaces.data?.workspaces ?? empty,
    workspaceIds: workspaces.data?.workspaceIds ?? empty,
    userOwnedWorkspaces: workspaces.data?.userOwnedWorkspaces ?? empty,
    userCollabWorkspaces: workspaces.data?.userCollabWorkspaces ?? empty,
    publicWorkspaces: workspaces.data?.publicWorkspaces,
    workspacesLoading:
      !tenantID || !user || workspaces.isLoading || queriesEnabled === false,
  };
};

export default useWorkspaces;
